import { Formatters, Messages } from '../../gen-src/Localize';
import {
  formatValueAsMetricNumber,
  DataRow,
  formatValueAsRelativePercentage,
  formatValueAsUnsignedPercentage,
} from '@tableau/metrics-engine';

export function formatRefreshedSince(date: Date): string {
  const fromDate = Formatters.formatLongBestFitRelativeTime(date);
  return Messages.refreshedSince({ fromDate });
}

export function formatDataPointAsMetricNumber(
  measureAccessor: (point: DataRow) => number,
  value?: DataRow,
  formatString?: string
): string {
  const measure = value && measureAccessor(value);
  return formatValueAsMetricNumber(measure, formatString);
}

/**
 * To be used by ConstnatComparisonValueInput
 *
 * When the formatString is a percentage, then we need to multiply the comparison value
 * by 100 for display. This function formats the display string to avoid floating point
 * precision errors after multiplication.
 *
 * @param value the preformatted number (i.e. 0.5 if the comparison is 50%)
 * @returns the formatted number
 */
export function formatAuthoredPercentOutOf100(value: number): string {
  // if the value is an integer, we don't need to worry about any of this
  if (Number.isInteger(value)) {
    return (value * 100).toString();
  }

  // Plus one so that the formatter trying to add a "%" at the end doesn't truncate our number at all
  const maxCharacters = value.toString().length + 1;

  // We don't want the "+", only the "-" when applicable
  const formattedWithPostfix =
    value < 0
      ? formatValueAsRelativePercentage(value, maxCharacters)
      : formatValueAsUnsignedPercentage(value, maxCharacters);

  // Removing the "%" at the end
  return formattedWithPostfix.substring(0, formattedWithPostfix.length - 1);
}
